import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Tooltip } from 'primereact/tooltip';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import './CoachingSummaryExpanded.scss';
import { useGetCoachingSummaryQuery } from '../coachingSlice';

interface CoachingSummaryExpandedGridProps {
    selectedEmployee: string;
    inputYear: number;
    inputMonth: number;
    flag: boolean;
    handleGridButonClick: (
        employeeNumber: string,
        columnName: string,
        isEdit: boolean,
        receiverName: string,
        rowData?: any
    ) => void;
    selectedEmployeeRole?: string;
}

export const CoachingSummaryExpandedGrid = ({
    selectedEmployee,
    inputYear,
    inputMonth,
    flag,
    handleGridButonClick,
    selectedEmployeeRole,
}: CoachingSummaryExpandedGridProps) => {
    const [coachingExpandedList, setCoachingExpandedList] = useState<any>([]);

    const { data: coachingExpandedGrid } = useGetCoachingSummaryQuery(
        {
            employeeNumber: selectedEmployee,
            year: inputYear,
            month: inputMonth,
            flag,
            loggedEmpRole: selectedEmployeeRole,
        },
        {
            skip: !selectedEmployee || !inputYear || !inputMonth,
        }
    );

    useEffect(() => {
        if (coachingExpandedGrid) {
            setCoachingExpandedList(coachingExpandedGrid.data);
        }
    }, [coachingExpandedGrid]);

    const buttonTemplate = (rowData: any, columnName: string) => {
        const color = rowData[columnName] ? '#2AA154' : '#3F5765';
        return (
            <div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        paddingRight: columnName === 'metrics' ? '17%' : '0px',
                        paddingLeft: columnName === 'strengths' ? '5px' : '0px',
                    }}
                >
                    <Button
                        type="button"
                        data-testid="coaching-summary-subgrid-button"
                        icon={rowData[columnName] ? 'pi pi-pencil' : 'pi pi-plus'}
                        style={{
                            background: 'transparent',
                            border: `${color} 1px solid`,
                            color: `${color}`,
                            width: '30px',
                            height: '30px',
                        }}
                        onClick={() => {
                            handleGridButonClick(
                                rowData.employee_number,
                                columnName,
                                rowData[columnName],
                                rowData.employee_name,
                                rowData
                            );
                        }}
                    />
                    {columnName === 'logs' && rowData.capsExists && (
                        <>
                            {!rowData.capsAcknowledged && (
                                <Tooltip target={'.custom-checkbox-not-ack'} position="top">
                                    <div id="coachingSummary" className="tooltip-content">
                                        <span
                                            style={{
                                                minWidth: '1rem',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            {'Cap Not Acknowledged'}
                                        </span>
                                    </div>
                                </Tooltip>
                            )}

                            {rowData.capsAcknowledged && (
                                <Checkbox
                                    checked={rowData.capsAcknowledged}
                                    id="ack-class"
                                    className="custom-checkbox"
                                    readOnly
                                />
                            )}
                            {!rowData.capsAcknowledged && (
                                <Checkbox
                                    checked={rowData.capsAcknowledged}
                                    id="ack-class"
                                    className="custom-checkbox-not-ack"
                                    readOnly
                                />
                            )}
                        </>
                    )}
                    {columnName === 'logs' && !rowData.capsExists && (
                        <div style={{ height: '20px', width: '20px' }}>&nbsp;</div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div>
            <DataTable
                value={coachingExpandedList}
                id="coaching-summary-subgrid"
                rows={5}
                paginator={coachingExpandedList?.length > 5}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 25, 50]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                emptyMessage="No records found."
                showGridlines={false}
                stripedRows
            >
                <Column header="Employee" field="employee_name" style={{ width: '9rem' }} />
                <Column
                    header="Strength"
                    field="strengths"
                    style={{ width: '5rem' }}
                    body={(rowData: any) => buttonTemplate(rowData, 'strengths')}
                />

                <Column
                    header="Metrics"
                    field="metrics"
                    style={{ width: '6rem' }}
                    body={(rowData: any) => buttonTemplate(rowData, 'metrics')}
                />

                <Column
                    header="Log" //aks: Discussions
                    field="logs"
                    style={{ width: '5rem' }}
                    body={(rowData: any) => buttonTemplate(rowData, 'logs')}
                />

                <Column style={{ width: '4rem' }} />
            </DataTable>
        </div>
    );
};
